import LoadingCard from './LoadingCard';


export default LoadingCard;



// WEBPACK FOOTER //
// ./src/components/LoadingCard/index.js